/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedCMSFAQ_buyPage = {
    readonly meta: {
        readonly header: string | null;
    } | null;
    readonly frequentlyAskedQuestions: ReadonlyArray<{
        readonly question: string | null;
        readonly answer: string | null;
    } | null> | null;
    readonly " $refType": "BuySharedCMSFAQ_buyPage";
};
export type BuySharedCMSFAQ_buyPage$data = BuySharedCMSFAQ_buyPage;
export type BuySharedCMSFAQ_buyPage$key = {
    readonly " $data"?: BuySharedCMSFAQ_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedCMSFAQ_buyPage">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedCMSFAQ_buyPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BuyPageFrequentlyAskedQuestionType",
      "kind": "LinkedField",
      "name": "frequentlyAskedQuestions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "question",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "answer",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'b79b1ccea0d0303ade4d7fda9dbdb019';
export default node;
